__turbopack_context__.v({
  "container": "JanFmG_container",
  "icon": "JanFmG_icon",
  "input": "JanFmG_input",
  "link": "JanFmG_link",
  "placeholder": "JanFmG_placeholder",
});
